/** AttachmentContent — renders BOTH `attachment_added` and `attachment_removed`. */
import React from 'react';
import { useTranslation } from 'localization';
import { TimelineEvent } from 'types/timeline';

interface Props {
  event: TimelineEvent;
}

const AttachmentContent: React.FC<Props> = ({ event }) => {
  const { t } = useTranslation();
  const payload = (event.payload ?? {}) as { name?: string; slotName?: string };
  const added = event.eventType === 'attachment_added';

  return (
    <div className="timeline-event-content">
      <span className="timeline-event-content__text">
        {t(added ? 'timeline.eventContent.attachmentAdded' : 'timeline.eventContent.attachmentRemoved', {
          name: payload.name ?? '',
          slot: payload.slotName ?? '',
        })}
      </span>
    </div>
  );
};

export default AttachmentContent;
